"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = __importDefault(require("vue"));
const Utils_1 = require("../../utils/Utils");
const EVENT_MODAL_CLOSE_KEY = "hugkumaChristmas202212";
exports.default = vue_1.default.extend({
    data() {
        return {
            borderImageUrl: 'url(images/game/common/img_dialog_frame.png)',
        };
    },
    methods: {
        eventModalClose() {
            localStorage.setItem(EVENT_MODAL_CLOSE_KEY, '1');
            const modalEle = document.querySelector('#modal-base');
            modalEle.style.display = 'none';
        },
        eventModalOpen() {
            const modalEle = document.querySelector('#modal-base');
            modalEle.style.display = 'flex';
        },
    },
    mounted() {
        const modalClose = localStorage.getItem(EVENT_MODAL_CLOSE_KEY);
        const isEventOutOfDate = Utils_1.Utils.isWithinPeriod('2022-12-12 00:00:00', '2022-12-20 13:59:59', 'Asia/Tokyo');
        if (modalClose === '1' || isEventOutOfDate) {
            const modalEle = document.querySelector('#modal-base');
            if (modalEle) {
                modalEle.style.display = 'none';
            }
        }
        if (isEventOutOfDate) {
            const bannerEle = document.querySelector('#event_banner');
            if (bannerEle) {
                bannerEle.style.display = 'none';
            }
        }
    },
});
